import React from "react";

const Fallback = () => {
  return (
    <div className="px-5 pt-28 text-xl text-center">
      Please scan your QR Code from your dealer.
    </div>
  );
};

export default Fallback;
